import { render, staticRenderFns } from "./politics_GIS.vue?vue&type=template&id=56e06108&scoped=true&"
import script from "./politics_GIS.vue?vue&type=script&lang=js&"
export * from "./politics_GIS.vue?vue&type=script&lang=js&"
import style0 from "./politics_GIS.vue?vue&type=style&index=0&id=56e06108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e06108",
  null
  
)

export default component.exports